import React from 'react';

import { IPublicationSearchResult } from 'services';
import { shortenStringWithEllipse } from 'helpers/text.helpers';

import styles from './SearchResultItem.module.scss';

/**
 * SearchResultItem
 *
 * @description Component used to render search result
 */
const SearchResultItem: React.FC<{ result: IPublicationSearchResult; }> = ({ result }) => {
  return (
    <div key={result.id} className={styles['search-result']}>
      <div className={styles['search-result__image-container']}>
        {
          result.url
            ?
            <a href={result.url} target='_blank' rel='noreferrer'>
              <span  className={styles['search-result__type-pill']}>
                {result.type}
              </span>
              <img
                src={result.imageUrl}
                alt={result.imageAltText ? result.imageAltText : result.title}
              />
            </a>
            :
            <>
              <span  className={styles['search-result__type-pill']}>
                {result.type}
              </span>
              <img
                src={result.imageUrl}
                alt={result.imageAltText ? result.imageAltText : result.title}
              />
            </>
        }
      </div>
      <div className={styles['search-result__content']}>
        <div>
          <div className={styles['search-result__content-header']}>
            {
              result.url
                ?
                <a href={result.url} target='_blank' rel='noreferrer'>
                  <h4>{result.title}</h4>
                </a>
                :
                <h4>{result.title}</h4>
            }
            <span className={styles['search-result__read-time']}>{result.readTime}</span>
          </div>
          <div className={styles['search-result__content-header']}>
            <span className={styles['search-result__author']}>{result.author}</span>
            <span className={styles['search-result__author']}>{result.date}</span>
          </div>
        </div>
        <div className={styles['search-result__content-tags']}>
          {
            result.categories &&
            // Limit to first 3 tags and we will shorten the tag text
            result.categories.slice(0, 3).map((category, index) =>
              <span key={index}>
                {shortenStringWithEllipse(category)}
              </span>
            )
          }
        </div>
      </div>
    </div>
  );
};

export default SearchResultItem;